/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import $ from "jquery";
import { useLocation } from "@reach/router";
function Seo({ description, lang, meta, title, image, location }) {
    const { site } = useStaticQuery(
        graphql`
            query {
                site {
                    siteMetadata {
                        title
                        description
                        author
                    }
                }
            }
        `
    )

    const metaDescription = description || site.siteMetadata.description;
    const defaultTitle = site.siteMetadata?.title;

    React.useEffect(() => {
        setTimeout(() => {
            var noResult = $('.no-result-page').length;
            var noResultMeta = $('meta[name=robots]').length;
            if (noResultMeta == 0 && noResult > 0) {
                $("head").append("<meta name=robots content=noindex />");
            } else if (noResultMeta > 0 && noResult == 0 && !hasPagination) {
                $('meta[name=robots]').remove();
            }
        }, 1000)
    })

    var currentUrl = '';
    if (location !== undefined && location.pathname) {
        currentUrl = process.env.GATSBY_SITE_URL + location.pathname;
    }
    

    //remove multiple slashes
    currentUrl = currentUrl.replace(/([^:]\/)\/+/g, "$1");
    //set lowercase url
    currentUrl = currentUrl.toLowerCase();

    // set no index for result pagination
    // set no index for result pagination
    let hasPagination = false;
    if (location !== undefined && location.pathname) {
        let pageStr = location.pathname.split('page-');
        hasPagination = pageStr[1] || false;
        if (pageStr[0] !== undefined) {
            currentUrl = process.env.GATSBY_SITE_URL + pageStr[0];
        }
    }
   
const indexedPaths = [
  "/sell/sell-home/",
  "/sell/sell-an-investment-property/",
  "/sell/sell-probate-or-discrete-matter-property/",
  "/let/investor-landlord/",
  "/let/first-time-landlord/",
  "/let/overseas-landlord/",
  "/buy/home/",
  "/buy/property-investment/",
  "/buy/development-opportunity/",
  "/rent/rent-a-home/",
  "/rent/student-rentals/",
  "/rent/search-agent-or-corporate-tenant/",
  "/local-living/garden-squares/",
  "/about/latest-property-news-and-videos/",
  "/about/tlc-vip/",
  "/about/meet-the-team/",
  "/about/our-awards/",
  "/contact/office/",
  "/"
];

// Normalize pathname to include trailing slash
const normalizedPath = location?.pathname?.endsWith("/")
  ? location.pathname
  : location.pathname + "/";

// Check using loop (same as .includes, but shown for clarity)
let shouldIndex = false;

for (let path of indexedPaths) {
  if (normalizedPath === path) {
    shouldIndex = true;
    break;
  }
}

console.log("Normalized Path:", normalizedPath);
console.log("Should Index:", shouldIndex);
    if (!currentUrl.endsWith('/'))
        currentUrl = currentUrl + '/';

    return (
        <Helmet
            htmlAttributes={{
                lang,
            }}
            title={title}
            titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
            link={[
                {
                    href: currentUrl,
                    rel: "canonical"
                }
            ]}
            meta={[
                  ...(shouldIndex ? [{ name: "robots", content: "index, follow" }] : [{ name: "robots", content: "" }]),
                {
                    name: `description`,
                    content: metaDescription,
                },
                {
                    property: `og:title`,
                    content: title,
                },
                {
                    property: `og:description`,
                    content: metaDescription,
                },
                {
                    property: `og:type`,
                    content: `website`,
                },
                {
                    name: `twitter:site`,
                    content: "@espace",
                },
                {
                    name: `twitter:card`,
                    content: "summary_large_image",
                },
                {
                    name: `twitter:title`,
                    content: title,
                },
                {
                    name: `twitter:image`,
                    content: image,
                },
                {
                    name: ` twitter:image:src`,
                    content: image,
                },
                {
                    name: `twitter:description`,
                    content: metaDescription,
                },
                {
                    name: `twitter:domain`,
                    content: "www.tlclondon.com",
                },
                {
                    name: `viewport`,
                    content: "width=device-width, initial-scale=1.0, shrink-to-fit=no, maximum-scale=1.0, user-scalable=0"
                },
            ].concat(meta)}
        />
    )
}

Seo.defaultProps = {
    lang: `en`,
    meta: [],
    description: ``,
}

Seo.propTypes = {
    description: PropTypes.string,
    lang: PropTypes.string,
    meta: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string.isRequired,
}

export default Seo
